import React from "react";
import { ErrorMessage, Field } from "formik";
import { Checkbox } from "primereact/checkbox";

function CheckBoxComponent(props: any) {
  const { name, label, value, ...rest } = props;
  return (
    <>
      {(!rest.disabled || value) && (
        <div className="flex flex-column w-full m-1">
          <div className="flex align-items-center">
            <Field onBlur={() => {}} checked={value} alt={name} name={name} as={Checkbox} />
            <label className="ml-4" htmlFor={name}>
              {" "}
              {label}
            </label>
          </div>
          <ErrorMessage name={name} render={(msg) => <div className="error">{msg}</div>} />
        </div>
      )}
    </>
  );
}
export default CheckBoxComponent;
